import { addIntent, createIntentMap, forEachIntent } from '../intent';
import { $revision, $subview } from './constants';
import { dynamic } from './dynamic';
import { isViewConfigIntent } from './ConfigIntent';
import { getPriority } from './priority';
export function assignObjectProps(target, source) {
    const keys = Object.keys(source);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        switch(key){
            case 'css':
            case 'inherits':
            case 'subviews':
            case 'uses':
                continue;
            default:
                target[key] = source[key];
        }
    }
    return target;
}
export function createViewRevision(instance, Component, props, forwardedRef, isElement) {
    const revision = createIntentMap({
        Component,
        initialProps: props,
        instance,
        props: {}
    });
    revision.props.ref = forwardedRef;
    assignObjectProps(revision.props, props);
    if (!isElement) {
        revision.props.inherits = {
            [$revision]: revision
        };
    }
    return revision;
}
function getInherits(props) {
    return props === null || props === void 0 ? void 0 : props.inherits;
}
export function getViewRevisionFromProps(props) {
    var _getInherits;
    return (_getInherits = getInherits(props)) === null || _getInherits === void 0 ? void 0 : _getInherits[$revision];
}
export function getSubviewIntentsFromProps(props) {
    var _getInherits;
    return (_getInherits = getInherits(props)) === null || _getInherits === void 0 ? void 0 : _getInherits[$subview];
}
export function addIntentsToRevision(revision, intents, priority, throwWhenPriorityMismatch = false) {
    if (!intents) {
        return;
    }
    forEachIntent(intents, (intent)=>{
        const intentPriority = getPriority(intent);
        if (intentPriority !== priority) {
            if (throwWhenPriorityMismatch && intentPriority > priority) {
                if (process.env.NODE_ENV !== 'production' || !dynamic.isIntent(intent)) {
                    throw new Error('Attempted to run an intent at a lower priority than expected.');
                } else {
                    // assignProps is now run at a higher priority, but to avoid breaking
                    // in production, we'll run at normal priority for backwards compat.
                    // We'll continue to throw in dev mode to highlight paths that need
                    // to be updated.
                    addIntentsToRevision(revision, intent(revision.props), priority);
                    // eslint-disable-next-line no-console
                    console.warn('An intent was run at a lower priority than expected.');
                }
            }
            return;
        }
        if (dynamic.isIntent(intent)) {
            addIntentsToRevision(revision, intent(revision.props), priority, true);
        } else if (isViewConfigIntent(revision, intent)) {
            addIntentsToRevision(revision, intent, priority, true);
        } else {
            addIntent(revision, intent);
        }
    });
}

//# sourceMappingURL=ViewRevision.js.map